import { Cta } from "@/components/Cta";
import { MaskedHeading } from "@/components/primitives";

export default function NotFound() {
    return (
        <section className="grid min-h-[80vh] place-items-center px-6 pt-24">
            <div className="max-w-xl text-center">
                <span className="font-mono text-sm uppercase tracking-[0.22em] text-navy">
                    404
                </span>
                <MaskedHeading
                    as="h1"
                    lines={["Page not found"]}
                    className="mt-4 text-5xl font-extrabold tracking-tight md:text-6xl"
                />
                <p className="mx-auto mt-6 max-w-md text-lg text-muted-foreground">
                    The page you&apos;re looking for has been moved or no longer
                    exists.
                </p>
                <div className="mt-8 flex justify-center">
                    <Cta to="/" testId="notfound-home" withArrow={false}>
                        Back to home
                    </Cta>
                </div>
            </div>
        </section>
    );
}
